import { ProjectDetailsResponseDTO } from './project.types';

export const projectDetailsMock: ProjectDetailsResponseDTO = {
  auth_token: 'sample-auth-token',
  project_uuid: 'sample-project-uuid',
  share_id: 'sample-share-id',
  target_site_type: 'live_site',
  tasks: [
    {
      task_uuid: 'sample-task-uuid-1',
      website_testing_url: 'https://example.com',
      response_uuid: 'sample-response-uuid-1',
      last_participation_event: 'UT_TASK_DONE',
    },
  ],
  next_task_uuid: 'sample-task-uuid-1',
  recording: {
    room_name: 'sample-room-name',
    room_url: 'https://example.com/room',
    token: 'sample-token',
  },
};
